import { AlertService } from '../../services/alert/alert.service'
import { Component } from '@angular/core'
import { UserService } from 'src/app/services/user/user.service'
import { FormGroup } from '@angular/forms'
import { NavController } from '@ionic/angular'

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage {

  constructor(
    private userService: UserService,
    private alert: AlertService,
    private navCtrl: NavController,
  ) { }

  login(form: FormGroup) {
    this.userService.login(form.value.username, form.value.password)
      .then(() =>
        this.navCtrl.navigateRoot('/dashboard', { animated: true, animationDirection: 'back' })
      )
      .catch((err) => this.alert.errorHandler(err, 'Ein Fehler beim Anmelden ist aufgetreten!'))
  }

  gotoRegister() {
    this.navCtrl.navigateForward('/signup')
  }

  gotoProfile() {
    this.navCtrl.navigateForward('/profile')
  }

  gotoForgotPw() {
    this.navCtrl.navigateForward('/forgotpw')
  }
}
